module.exports = __webpack_public_path__ + "img/credit-green.73b4757c.svg";